import { useSelector } from "react-redux";
import { Getters } from "store/auth";

export const useAuthData = () => {
  const isAuthenticated = useSelector(Getters.isAuthenticate);
  const user = useSelector(Getters.userData);

  return { isAuthenticated, user };
};
